// "Submit as deal →" — opens salesIntake with lead fields pre-filled (§11.2).

import type { Lead } from "@/types/lead";
import { canAccessPrimaryMode } from "@/components/shell/modes/modesRegistry";
import { useAuth } from "@/contexts/AuthContext";
import { SALES_REP_ROLES } from "@/lib/roles/turboSalesRoles";
import { leadToIntakePrefill } from "@/lib/sales-intake/leadToIntakePrefill";
import { setLeadIntakePrefill } from "@/lib/sales-intake/leadIntakePrefill";

const LEAVE_LEAD_HINT =
  "Opens Order Intake with this lead's contact and product details pre-filled. Your lead stays saved here.";

export function LeadSummarySubmitAsDealAction(props: {
  lead: Lead;
  workspaceLocationId?: string | null;
  onOpenSalesIntake: () => void;
}) {
  const auth = useAuth();
  const { lead, workspaceLocationId, onOpenSalesIntake } = props;

  const canHandoff =
    !lead.isTest &&
    Boolean(lead.extracted) &&
    canAccessPrimaryMode("salesIntake", auth) &&
    auth.hasRole(...SALES_REP_ROLES);

  if (!canHandoff) return null;

  const prefill = leadToIntakePrefill(lead, workspaceLocationId);
  const hasMinimum = Boolean(prefill?.customer.name.trim());

  return (
    <button
      type="button"
      title={hasMinimum ? LEAVE_LEAD_HINT : "Add a customer name before submitting as a deal"}
      disabled={!hasMinimum}
      onClick={() => {
        if (!prefill) return;
        setLeadIntakePrefill(prefill);
        onOpenSalesIntake();
      }}
      className="mt-3 w-full py-4 text-lg rounded-2xl border-2 border-indigo-600 text-indigo-700 bg-white hover:bg-indigo-50 font-semibold disabled:opacity-40 disabled:cursor-not-allowed dark:border-indigo-500 dark:text-indigo-200 dark:bg-zinc-900 dark:hover:bg-indigo-950/40"
    >
      Submit as deal →
    </button>
  );
}
